import Link from "@tiptap/extension-link"

export const NonInclusiveLink = Link.extend({
  inclusive: false
})
